/** The red "Video" pill shown next to lessons/cards whose article embeds a video.
 * Shared by the curriculum tables, search results, standalone cards, and the
 * course sidebar - keep this the single source of the pill's look. */
export default function VideoPill({
  size = 'md',
  className = '',
}: {
  size?: 'md' | 'sm'
  className?: string
}) {
  const sizeClasses = size === 'sm' ? 'text-[9px] px-1' : 'text-[10px] px-1.5'
  return (
    <span
      className={`font-semibold text-red-400 bg-red-400/10 py-0.5 rounded ${sizeClasses} ${className}`.trim()}
    >
      Video
    </span>
  )
}
